import { z } from "zod";
import { schemes } from "@zeal/common";

export const downloadPartnerBusinessDocumentsZipInternalParamsSchema = z.object(
  {
    partnerID: schemes.uuid(),
  }
);

export type TDownloadPartnerBusinessDocumentsZipInternalParams = z.infer<
  typeof downloadPartnerBusinessDocumentsZipInternalParamsSchema
>;
